
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/residents/maintenance-ticket",
      function () {
        return require("private-next-pages/residents/maintenance-ticket/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/residents/maintenance-ticket"])
      });
    }
  